/**
 * El contenido de /premium en UN solo sitio.
 *
 * Lo usan `pages/Premium.jsx` (lo que ve el visitante) y `data/landingBodies.js`
 * (el HTML que se sirve a quien no ejecuta JavaScript). Estaba solo en el .jsx,
 * asi que /premium se servia con el #root VACIO: 6.177 bytes sin una palabra
 * sobre el precio, lo que incluye ni hasta cuando dura la oferta. Es el mismo
 * agujero que se tapo el 29-ago para los 116 posts y las 14 landings, y la
 * pagina de dinero se quedo fuera.
 *
 * Se saca aqui en vez de duplicar el copy porque `landingBodies.js` avisa en su
 * cabecera de que copiar a mano se queda viejo. Con esto, tocar el texto una vez
 * cambia las dos versiones.
 */
import { PRECIO_ANUAL, PRECIO_MENSUAL_EQUIV, DIAS_PRUEBA } from "../config/precios.js";

const BENEFICIOS = [
  "Escaneos de comida ilimitados",
  "Plan de alimentación personalizado",
  "Rutinas de gym y de casa adaptadas a tu nivel",
  "+100 recetas con los macros ya calculados",
  "Lista de la compra inteligente",
  "Seguimiento de progreso y gráficos",
];

const COMO_FUNCIONA = [
  {
    icon: "📸",
    titulo: "Escanea tu comida",
    desc: "Una foto y sabes calorías y macros en 3 segundos. Sin pesar ni apuntar a mano.",
  },
  {
    icon: "🎯",
    titulo: "Recibe tu plan",
    desc: "Nutrición y entrenamiento personalizados según tu objetivo y tu nivel.",
  },
  {
    icon: "📈",
    titulo: "Progresa",
    desc: "Sigue tu evolución con gráficos y ajusta sobre la marcha. Sin agobios.",
  },
];

const INCLUYE = [
  ["Escaneos ilimitados", "Registra todo lo que comes sin límites diarios."],
  ["Plan de alimentación personalizado", "Qué comer cada día según tu objetivo, sin pensar."],
  ["Rutinas de gym y de casa", "Entrenamientos adaptados a tu nivel y a tu material."],
  ["+100 recetas con macros", "Cocina rico y sano con las cuentas ya hechas."],
  ["Lista de la compra inteligente", "Tu plan convertido en lista de compra en segundos."],
  ["Progreso y gráficos", "Ve qué funciona y mantén la motivación."],
];

const FAQS = [
  [
    "¿Cuánto cuesta Wayo Premium?",
    `${PRECIO_ANUAL}/año (equivale a ${PRECIO_MENSUAL_EQUIV}/mes), con ${DIAS_PRUEBA} días de prueba gratis. Cancela cuando quieras.`,
  ],
  [
    "¿Tengo que pagar durante la prueba?",
    "No. Los 7 días son gratis; si cancelas antes de que terminen, no se te cobra nada.",
  ],
  [
    "¿Se renueva automáticamente?",
    "Sí, es una suscripción anual que se renueva sola. Puedes cancelarla cuando quieras desde tu cuenta.",
  ],
  [
    "¿Funciona sin contar calorías a mano?",
    "Sí. Escaneas tu comida con una foto y Wayo calcula las calorías y los macros por ti.",
  ],
  [
    "¿Está disponible en iPhone y Android?",
    "Sí, Wayo está disponible en App Store y en Google Play.",
  ],
  [
    "¿Necesito saber de nutrición o entrenamiento?",
    "No. Wayo te da un plan personalizado y recetas listas para seguir; tú solo tienes que empezar.",
  ],
];

export { BENEFICIOS, COMO_FUNCIONA, INCLUYE, FAQS };
